import { render, staticRenderFns } from "./WUserAccountRecoveryTwo.vue?vue&type=template&id=6764f10d&"
import script from "./WUserAccountRecoveryTwo.vue?vue&type=script&lang=ts&"
export * from "./WUserAccountRecoveryTwo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports